// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3536":"275d06f6","4336":"3b55f508"}[chunkId] + ".chunk.css";
};